export default {
  title: 'Henkilökunnan kirjautumistiedot',
  form: {
    username: {
      label: 'Käyttäjätunnus',
      placeholder: 'Käyttäjätunnus',
    },
    password: {
      label: 'Salasana',
      placeholder: 'Salasana',
    },
    button: {
      title: 'Tallenna',
    },
    success: 'Tietosi tallennettiin onnistuneesti.',
  },
};
